import "whatwg-fetch";
import * as constants from "../constants/slack";

export const authSlackError = () => ({
  type: constants.AUTHENTICATED_SLACK_ERROR
});

export const noSlackCode = () => ({
  type: constants.NO_SLACK_CODE
});

export const authSlackSuccess = () => ({
  type: constants.AUTHENTICATED_SLACK
});

export const authingSlack = () => ({
  type: constants.AUTHENTICATING_SLACK
});

export const authSlack = body => {
  return dispatch => {
    dispatch(authingSlack());
    fetch(constants.SLACK_ENDPOINT, {
      method: "POST",
      body,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
      .then(response => response.json())
      .then(res => {
        if (res.ok) {
          dispatch(authSlackSuccess());
        } else {
          dispatch(authSlackError());
        }
      })
      .catch(err => dispatch(authSlackError()));
  };
};



// WEBPACK FOOTER //
// ./src/actions/slack.js